module.exports = __webpack_public_path__ + "static/media/t3.feb2c07a.jpg";